<svg
  width="80px"
  height="80px"
  viewBox="0 0 80 80"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  aria-labelledby="expenditure-icon-title expenditure-icon-desc"
  role="img"
>
  <title id="expenditure-icon-title">Expenditure Icon</title>
  <desc id="expenditure-icon-desc">This is a wallet icon depicting spending.</desc>
  <defs>
    <rect
      id="path-1"
      x="0"
      y="0"
      width="80"
      height="80"
    ></rect>
  </defs>
  <g
    id="Expenditure-Icon"
    stroke="none"
    stroke-width="1"
    fill="none"
    fill-rule="evenodd"
  >
    <g>
      <mask
        id="693f6433-fdd0-4489-b898-93b545195b29"
        fill="white"
      >
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask"></g>
      <g
        mask="url(#693f6433-fdd0-4489-b898-93b545195b29)"
        fill="#BA2F7D"
        fill-rule="nonzero"
        id="Shape"
        class="fill"
      >
        <g transform="translate(12.000000, 13.000000)">
          <path
            d="M55.6470949,17.4249965 L53.168185,17.4249965 L53.168185,13.6400747 C53.168185,10.7524405 50.8206081,8.40317877 47.9312826,8.35423582 L47.9312826,3.80254117 C47.9312826,2.75842484 47.4716171,1.76325146 46.6672027,1.09436443 C45.8627882,0.425477406 44.8121245,0.131819687 43.7614607,0.3275915 C43.7614607,0.3275915 43.745044,0.3275915 43.745044,0.3275915 L4.04965229,8.37055014 L4.08248554,8.55000763 C1.83340834,9.1699517 0.175329522,11.2092414 0.175329522,13.6400747 L0.175329522,43.4137046 C0.175329522,46.3339675 2.5557397,48.6995436 5.49431501,48.6995436 L47.8491995,48.6995436 C50.7877748,48.6995436 53.168185,46.3339675 53.168185,43.4137046 L53.168185,34.0819149 L53.3323512,34.0819149 C56.1395936,34.0819149 58.4379206,31.8142247 58.4379206,29.008162 L58.4379206,20.1984305 C58.4379206,20.1984305 58.4379206,20.1984305 58.4379206,20.1984305 C58.4379206,18.6648846 57.1902573,17.4249965 55.6470949,17.4249965 Z M44.0569598,1.94270896 C44.615125,1.84482305 45.1732902,2.00796622 45.6001223,2.36688121 C46.0269544,2.7257962 46.2896204,3.26416869 46.2896204,3.81885549 L46.2896204,8.37055014 L12.3400463,8.37055014 L44.0569598,1.94270896 Z M51.5265228,43.4300189 C51.5265228,45.43668 49.8848606,47.0844261 47.8491995,47.0844261 L5.49431501,47.0844261 C3.47507052,47.0844261 1.81699171,45.4529943 1.81699171,43.4300189 L1.81699171,13.6400747 C1.81699171,11.6334137 3.4586539,9.98566757 5.49431501,9.98566757 L47.8491995,9.98566757 C49.868444,9.98566757 51.5265228,11.6170994 51.5265228,13.6400747 L51.5265228,22.9718645 L50.8041914,22.9718645 L44.1718762,22.9718645 C41.5288,22.9718645 39.1648065,24.6522392 38.3111421,27.1320155 C37.9992263,28.029303 37.9992263,29.0244764 38.3111421,29.9380782 C39.1648065,32.4341688 41.5288,34.0982292 44.1718762,34.0982292 L51.5265228,34.0982292 L51.5265228,43.4300189 L51.5265228,43.4300189 Z M56.7962584,29.0244764 C56.7962584,30.9169373 55.2366793,32.4667974 53.3323512,32.4667974 L44.1718762,32.4667974 C42.2182982,32.4667974 40.4945529,31.2432236 39.8543046,29.3997057 C39.6573052,28.8450189 39.6573052,28.2250748 39.8543046,27.6540737 C40.4945529,25.8268701 42.2182982,24.586982 44.1718762,24.586982 L50.8041914,24.586982 L54.0054327,24.586982 C55.0560965,24.586982 56.0410938,24.2117527 56.7962584,23.6081229 L56.7962584,29.0244764 Z M54.0054327,22.9718645 L53.168185,22.9718645 L53.168185,19.0564283 L55.6470949,19.0564283 C56.2873432,19.0564283 56.7962584,19.5621721 56.7962584,20.1984305 C56.7962584,21.7319764 55.5485951,22.9718645 54.0054327,22.9718645 Z"
          ></path>
          <path
            d="M44.7300414,25.6800412 C43.1540456,25.6800412 41.8571325,26.952558 41.8571325,28.5350468 C41.8571325,30.1175357 43.137629,31.3900524 44.7300414,31.3900524 C46.306037,31.3900524 47.6029502,30.1175357 47.6029502,28.5350468 C47.6029502,26.952558 46.306037,25.6800412 44.7300414,25.6800412 Z M44.7300414,29.7423064 C44.0569598,29.7423064 43.4987947,29.2039339 43.4987947,28.5187325 C43.4987947,27.8335312 44.0405432,27.2951587 44.7300414,27.2951587 C45.4195394,27.2951587 45.961288,27.8335312 45.961288,28.5187325 C45.961288,29.2039339 45.4031228,29.7423064 44.7300414,29.7423064 Z"
          ></path>
        </g>
      </g>
    </g>
  </g>
</svg>
